export default {
    change(state, newList) {
        state.list = newList;
    },
};
